/*----- Core -----*/
import React from 'react'

/*----- Styles -----*/
import Styles from './Styles'

/*----- Utils -----*/
import ScrollTop from '../../utils/ScrollTop'

/*----- Assets -----*/
import BlueCircle   	  from '../../assets/svg_shapes/blue_circle.svg'
import logoNuestraCasa 	from '../../assets/logo_nuestra_casa.svg'
import guilleImage	    from '../../assets/our-home/guille.jpg'
import carlosImage	    from '../../assets/our-home/carlos.jpg'
import JoinUsVideo	    from '../../assets/videos/join_us.mp4'

/*----- Components -----*/
import SectionContainer  from '../../components/commons/SectionContainer'
import SectionTitle      from '../../components/text/SectionTitle'
import HeroParagraph 		 from '../../components/hero/HeroParagraph'
import Video 						 from '../../components/Video'
import QuoteCard				 from '../../components/card/QuoteCard'

/*----- Ant Design -----*/
import { Row, Col } from 'antd'
import Paragraph from '../../components/text/Paragraph'

function OurHome() {
	ScrollTop()
	return (
		<Styles>
			<div className="circle-container">
				<img src={BlueCircle} alt="" className="circle-container__blue-circle "/>
			</div>
			<SectionContainer>
				<Row className="our-home-wellcome">
					<Col xs={24} sm={{span: 24}} md={{span: 24}} lg={{span: 12 }} xl={{span: 12 }}>
						<img src={logoNuestraCasa} alt="logo nuestra casa" className="our-home__logo"/>
						<HeroParagraph
							title       	= "Sumate al encuentro de productores"
							subtitle    	= "Este canal de trabajo remoto funciona como una oficina virtual donde los productores se pueden conectar de lunes a viernes entre las 10 y las 17hs. para realizar consultas, agilizar gestiones y compartir su jornada."
						/>
					</Col>
					<Col xs={24} sm={{span: 24}} md={{span: 124}} lg={{span: 12 }} xl={{span: 12 }}>
					<Video 
						videoUrl 		= { JoinUsVideo }
						height   		= { 400 }
						width   		= { 400 }
						coverColor  = 'rgba(47, 137, 252, 0.5)'
					/>
					</Col>
				</Row>
			</SectionContainer>
			<SectionContainer noSpacing>
					<SectionTitle content="¿Por qué creamos Nuestra Casa?" />
				<Row className="quote-card-container">
					<Col xs={24} sm={{span: 24}} md={{span: 24}} lg={{span: 12 }} xl={{span: 12 }}>
						<QuoteCard
							imageUrl    = { guilleImage }
							name        = "Guillermo Ludueña"
							description = "“Sentíamos que en este contexto, los productores nos necesitaban más cerca que nunca, y buscamos generar un canal para estar en contacto permanente. La idea es acompañarlos como siempre y tener un vínculo fluido, a pesar del aislamiento”"
						/>
					</Col>
					<Col xs={24} sm={{span: 24}} md={{span: 24}} lg={{span: 12 }} xl={{span: 12 }}>
						<QuoteCard
							imageUrl    = { carlosImage }
							name        = "Carlos Bernasconi"
							description = "“El escenario mundial que estamos atravesando exige nuevas modalidades para ejercer la profesión, el trabajo remoto llegó para quedarse. Nos gusta siempre estar a la vanguardia de los cambios que propone el contexto, y esta herramienta nos pareció oportuna y necesaria”"
						/>
					</Col>
				</Row>
			</SectionContainer>
			<SectionContainer noSpacing>
				<SectionTitle content="¿Qué hacemos en Nuestra Casa?" />
				<Row>
					<Row>
						<Col className="our-home-item" xs={24} sm={{span: 24}} md={{span: 12}} lg={{span: 12 }} xl={{span: 12 }}>
							<Paragraph bold content="Capacitaciones"/>
							<Paragraph content="Utilizamos este canal para que nuestros productores estén actualizados respecto a las novedades del mercado asegurador. Coordinamos reuniones de equipo para promover la actualización permanente. En algunas oportunidades generamos charlas en conjunto con otras organizaciones de productores de seguros, porque creemos en el trabajo colaborativo y en equipo."/>
						</Col>
						<Col className="our-home-item" xs={24} sm={{span: 24}} md={{span: 12}} lg={{span: 12 }} xl={{span: 12 }}>
							<Paragraph bold content="Consultas"/>
							<Paragraph content="A la hora de trabajar de manera remota es crucial poder garantizar la fluidez de la comunicación entre los productores y la organización. Nuestro representantes administrativos se encuentran online en la plataforma, para que aquellos PAS que tengan dudas o consultas, puedan conectarse cuando lo deseen y obtener una respuesta rápida."/>
						</Col>
					</Row>
					<Row>
						<Col className="our-home-item" xs={24} sm={{span: 24}} md={{span: 12}} lg={{span: 12 }} xl={{span: 12 }}>
							<Paragraph bold content="Lista de difusión"/>
							<Paragraph content="Complementamos el funcionamiento de Nuestra Casa con una lista de difusión de WhatsApp, donde enviamos circulares importantes y novedades. El objetivo es garantizar que nuestro equipo de productores esté actualizado de una manera rápida y fácil, tal como exige la coyuntura actual."/>
						</Col>
						<Col className="our-home-item" xs={24} sm={{span: 24}} md={{span: 12}} lg={{span: 12 }} xl={{span: 12 }}>
							<Paragraph bold content="Trabajo en equipo"/>
							<Paragraph content="Nuestros valores son el trabajo colaborativo y en equipo, Nuestra Casa se configura como una herramienta que garantiza que esta dinámica no se pierda, sino que se exprese bajo canales más modernos y acordes al contexto actual."/>
						</Col>
					</Row>
				</Row>
			</SectionContainer>
		</Styles>
	)
}
export default OurHome
